import { FilterSchemaType, LabBookSampleTypes } from "../enums";
import APPCONFIG from "../config/app.config";
const TRIAL_MASTER_DATA_BASE_URL = `${APPCONFIG.apiBaseURL}trialmasterdata/v1`;
const TRIAL_MASTER_BASE_URL = `${APPCONFIG.apiBaseURL}trialmaster/v1`;
const TRIAL_AUTH_BASE_URL = `${APPCONFIG.apiBaseURL}trialauth/v1`;
const COLLECTION_MASTER_BASE_URL = `${APPCONFIG.apiBaseURL}collectionmaster/v1`;
const REPORTING_BASE_URL = `${APPCONFIG.apiBaseURL}trialreporting/v1`;
const FILE_STORE_BASE_URL = `${APPCONFIG.apiBaseURL}trialmgmtfilestoretoken/v1`;



export const URLConfig = {
  getCropsMasterDataURl() {
    return `${TRIAL_MASTER_DATA_BASE_URL}/masterdata/crops`; // TO DO : update it later on
  },

  getSeasonsMasterDataURl() {
    return `${TRIAL_MASTER_DATA_BASE_URL}/season`;
  },

  getSeasonsNextPageURl(nextPageURI: string) {
    return `${TRIAL_MASTER_DATA_BASE_URL}${nextPageURI}`;
  },

  getTrialsUrl() {
    return `${TRIAL_MASTER_BASE_URL}/trial`;
  },

  getTrialExperimentsUrl() {
    return `${TRIAL_MASTER_BASE_URL}/OnFarmTrialLocation`;
  },

  getTrialExperimentByIdUrl(id: string) {
    return `${TRIAL_MASTER_BASE_URL}/OnFarmTrialLocation/${id}`;
  },

  getTrialLocations(trialId: string) {
    return `${TRIAL_MASTER_BASE_URL}/trial/${trialId}/location`;
  },

  getTrialByIdUrl(id: string) {
    return `${TRIAL_MASTER_BASE_URL}/trial/${id}`;
  },

  getTrialsNextPage(nextPageURI: string) {
    return `${TRIAL_MASTER_BASE_URL}${nextPageURI}`;
  },

  getTrialExperimentsNextPage(nextPageURI: string) {
    return `${TRIAL_MASTER_BASE_URL}${nextPageURI}`;
  },
  getAgronomicData() {
    return `${COLLECTION_MASTER_BASE_URL}/OnFarmAgronomicData`;
  },
  getAgronomicDataNextPage(nextPageURI: string) {
    return `${COLLECTION_MASTER_BASE_URL}${nextPageURI}`;
  },
  getHarvestData() {
    return `${COLLECTION_MASTER_BASE_URL}/OnFarmHarvestData`;
  },
  getHarvestDataNextPage(nextPageURI: string) {
    return `${COLLECTION_MASTER_BASE_URL}${nextPageURI}`;
  },
  updateTrialUrl(trialId: string) {
    return `${TRIAL_MASTER_BASE_URL}/trial/${trialId}`;
  },

  addTrialProductsURL(id: string) {
    return `${TRIAL_MASTER_BASE_URL}/trial/${id}/addproducts`;
  },

  getTrialProductsURL(id?: string) {
    return `${TRIAL_MASTER_BASE_URL}/trial/${id}/products`;
  },

  deleteTrialProductsURL(trialId: string, productId: string) {
    return `${TRIAL_MASTER_BASE_URL}/trial/${trialId}/product/${productId}`;
  },
  getTrialLocationURL() {
    return `${TRIAL_MASTER_BASE_URL}/trialLocation`;
  },
  getTrialMasterLocationURL() {
    return `${TRIAL_MASTER_BASE_URL}/trialLocation/master-location`;
  },
  getTrialLocationNextPageURL(nextPageURI: string) {
    return `${TRIAL_MASTER_BASE_URL}${nextPageURI}`;
  },
  getTrialLocationByIdURL(id: string) {
    return `${TRIAL_MASTER_BASE_URL}/triallocation/${id}`;
  },
  getDemoTrialLocationByIdURL(id: string) {
    return `${TRIAL_MASTER_BASE_URL}/triallocation/mapping-sheet/trial/${id}/locations`;
  },
  getTrialsByLocationIdURL() {
    return `${TRIAL_MASTER_BASE_URL}/triallocation/trials`;
  },
  getTrialsByLocationIdNextPageURL(nextPageURI: string) {
    return `${TRIAL_MASTER_BASE_URL}${nextPageURI}`;
  },
  updateTrialLocationUsingPatchURL(trialLocationId: string) {
    return `${TRIAL_MASTER_BASE_URL}/triallocation/${trialLocationId}`;
  },
  getPrimaryTillageURL() {
    return `${TRIAL_MASTER_BASE_URL}/tillagetype`;
  },
  getApplicationStageListURL() {
    return `${TRIAL_MASTER_BASE_URL}/applicationtype`;
  },
  getCropStageURL() {
    return `${TRIAL_MASTER_BASE_URL}/cropstage`;
  },

  getUsersMasterDataURL() {
    return `${TRIAL_AUTH_BASE_URL}/user`;
  },

  getUsersNextPageURl(nextPageURI: string) {
    return `${TRIAL_AUTH_BASE_URL}${nextPageURI}`;
  },

  updateUserMasterDataURL(userId: string) {
    return `${TRIAL_AUTH_BASE_URL}/user/${userId}`;
  },
  getUserAccessPermissionsDataURL(userId: string) {
    return `${TRIAL_AUTH_BASE_URL}/user/ag2AgId/${userId}`;
  },

  getApplicationConfigURL() {
    return `${TRIAL_AUTH_BASE_URL}/Application`;
  },

  getTreatmentProductsMasterDataURL() {
    return `${TRIAL_MASTER_DATA_BASE_URL}/TreatmentProduct`;
  },

  getTreatmentProductsNextPageURl(nextPageURI: string) {
    return `${TRIAL_MASTER_DATA_BASE_URL}${nextPageURI}`;
  },

  updateTreatmentProductsMasterDataURL(treatmentProductId: string) {
    return `${TRIAL_MASTER_DATA_BASE_URL}/TreatmentProduct/${treatmentProductId}`;
  },

  patchEnableOnFarmTreatmentProductsMasterDataURL() {
    return `${TRIAL_MASTER_DATA_BASE_URL}/TreatmentProduct/bulk-update`;
  },

  patchFilteredUpdateTreatmentProductsMasterDataURL() {
    return `${TRIAL_MASTER_DATA_BASE_URL}/TreatmentProduct/filtered-update`;
  },

  getTreatmentProductParentTypeURL() {
    return `${TRIAL_MASTER_DATA_BASE_URL}/Enum/TrtProductParentTypeEnum`;
  },
  getTreatmentProductTypeURL() {
    return `${TRIAL_MASTER_DATA_BASE_URL}/Enum/TrtProductTypeEnum`;
  },
  getTreatmentProductUnitURL() {
    return `${TRIAL_MASTER_DATA_BASE_URL}/Enum/TrtProductUnitEnum`;
  },

  getTeamsMasterDataURL() {
    return `${TRIAL_AUTH_BASE_URL}/team`;
  },
  getTeamsNextPageURl(nextPageURI: string) {
    return `${TRIAL_AUTH_BASE_URL}${nextPageURI}`;
  },

  updateTeamsMasterDataURL(teamId: string) {
    return `${TRIAL_AUTH_BASE_URL}/team/${teamId}`;
  },

  getCropsMasterDataURL() {
    return `${TRIAL_MASTER_DATA_BASE_URL}/crop`;
  },
  getCropsNextPageURl(nextPageURI: string) {
    return `${TRIAL_MASTER_DATA_BASE_URL}${nextPageURI}`;
  },

  getLocationMasterDataURL() {
    return `${TRIAL_MASTER_DATA_BASE_URL}/Location`;
  },
  getLocationNextPageURl(nextPageURI: string) {
    return `${TRIAL_MASTER_DATA_BASE_URL}${nextPageURI}`;
  },

  updateLocationMasterDataURL(locationId: string) {
    return `${TRIAL_MASTER_DATA_BASE_URL}/Location/${locationId}`;
  },
  getTreatmentsMasterDataURL() {
    return `${TRIAL_MASTER_DATA_BASE_URL}/TreatmentGroup`;
  },
  getTreatmentsNextPageURl(nextPageURI: string) {
    return `${TRIAL_MASTER_DATA_BASE_URL}${nextPageURI}`;
  },

  updateTreatmentsMasterDataURL(treatmentId: string | number) {
    return `${TRIAL_MASTER_DATA_BASE_URL}/TreatmentGroup/${treatmentId}`;
  },

  getProductsMasterDataURL() {
    return `${TRIAL_MASTER_DATA_BASE_URL}/product`;
  },

  getProductsNextPageURl(nextPageURI: string) {
    return `${TRIAL_MASTER_DATA_BASE_URL}${nextPageURI}`;
  },

  updateProductsMasterDataURL(productId: string) {
    return `${TRIAL_MASTER_DATA_BASE_URL}/product/${productId}`;
  },
  deleteProductsMasterDataURL(productId: string) {
    return `${TRIAL_MASTER_DATA_BASE_URL}/product/${productId}`;
  },
  getProductsAttributeMasterDataURL() {
    return `${TRIAL_MASTER_DATA_BASE_URL}/ProductAttribute`;
  },
  getProductsCategoryMasterDataURL() {
    return `${TRIAL_MASTER_DATA_BASE_URL}/ProductCategory`;
  },
  getAttributesTrialMasterURL() {
    return `${TRIAL_MASTER_BASE_URL}/step`;
  },
  getBrandsTrialMasterURL() {
    return `${TRIAL_MASTER_DATA_BASE_URL}/brand`;
  },
  getBrandsNextPageURl(nextPageURI: string) {
    return `${TRIAL_MASTER_DATA_BASE_URL}${nextPageURI}`;
  },
  getUserGroupsMasterDataURL() {
    return `${TRIAL_AUTH_BASE_URL}/usergroup`;
  },
  getRandomizationTrialMasterURL() {
    return `${TRIAL_MASTER_BASE_URL}/randomizationtype/with-randomization-method`;
  },
  getRandomizationURL() {
    return `${TRIAL_MASTER_BASE_URL}/treatmenttype`;
  },
  getInventoryTrialMasterURL() {
    return `${TRIAL_MASTER_BASE_URL}/inventory`;
  },
  getInventoryNextPageURL(nextPageURI: string) {
    return `${TRIAL_MASTER_BASE_URL}${nextPageURI}`;
  },
  getInventoryProductTrialMasterURL(crop?: string, season?: string) {
    return `${TRIAL_MASTER_BASE_URL}/inventory/products/${crop}/${season}`;
  },
  getContentLengthForInventoryURL() {
    return `${TRIAL_MASTER_BASE_URL}/inventory`;
  },
  addInventoryProductsTrialMasterURL() {
    return `${TRIAL_MASTER_BASE_URL}/inventory/addproducts`;
  },
  addVariantTrialMasterURL(inventoryId: string) {
    return `${TRIAL_MASTER_BASE_URL}/inventory/${inventoryId}/addvariants`;
  },
  updateInventoryTrialMasterURL() {
    return `${TRIAL_MASTER_BASE_URL}/inventory`;
  },
  deleteInventoryTrialMasterURL(inventoryId: string) {
    return `${TRIAL_MASTER_BASE_URL}/inventory/${inventoryId}`;
  },
  getAllCountyMasterDataURL() {
    return `${TRIAL_MASTER_DATA_BASE_URL}/county`;
  },
  getAllStateMasterDataURL() {
    return `${TRIAL_MASTER_DATA_BASE_URL}/state`;
  },
  getAllLocationRegionMasterDataURL() {
    return `${TRIAL_MASTER_DATA_BASE_URL}/Enum/RegionEnum`;
  },
  getMappingSheetTrialMasterURL(
    seasonId?: string,
    cropId?: string,
    teamId?: string
  ) {
    return `${TRIAL_MASTER_BASE_URL}/season/${seasonId}/crop/${cropId}/mapping-sheet/team/${teamId}`;
  },
  getTrialsLocationsTrialMasterURL() {
    return `${TRIAL_MASTER_BASE_URL}/triallocation`;
  },
  getTrialsLocationsNextPageURL(nextPageURI: string) {
    return `${TRIAL_MASTER_BASE_URL}${nextPageURI}`;
  },

  createMappingSheetTrialMasterURL(
    seasonId?: string,
    cropId?: string,
    teamId?: string
  ) {
    return `${TRIAL_MASTER_BASE_URL}/triallocation/season/${seasonId}/crop/${cropId}/mapping-sheet/team/${teamId}`;
  },
  addRepsTrialMasterURL(trialLocationId: string) {
    return `${TRIAL_MASTER_BASE_URL}/triallocation/mapping-sheet/${trialLocationId}/rep`;
  },
  deleteMappingSheetTrialTrialMasterURL(
    seasonId?: string,
    teamId?: string,
    trialId?: string
  ) {
    return `${TRIAL_MASTER_BASE_URL}/triallocation/season/${seasonId}/mapping-sheet/team/${teamId}/trial/${trialId}`;
  },
  deleteMappingSheetTrialLocationTrialMasterURL(
    seasonLocationId: string,
    cropId?: string
  ) {
    return `${TRIAL_MASTER_BASE_URL}/triallocation/${seasonLocationId}/crop/${cropId}/mapping-sheet`;
  },

  getTreatmentInfoTrialMasterURL(trialId?: string) {
    return `${TRIAL_MASTER_BASE_URL}/triallocation/${trialId}/treatments`;
  },

  getTreatmentInfoNextPageTrialMasterURL(nextPageURI: string) {
    return `${TRIAL_MASTER_BASE_URL}${nextPageURI}`;
  },

  getFieldJournalTrialMasterURL(answerPlotLocationId?: string) {
    return `${TRIAL_MASTER_BASE_URL}/triallocation/${answerPlotLocationId}/field-journal`;
  },
  getFieldBookURL() {
    return `${COLLECTION_MASTER_BASE_URL}/fieldbook`;
  },
  getFieldBookNextPageURL(nextPageURI: string) {
    return `${COLLECTION_MASTER_BASE_URL}${nextPageURI}`;
  },
  getFieldBookCatalogURL() {
    return `${COLLECTION_MASTER_BASE_URL}/FieldBookCatalog`;
  },
  getFieldBookCatalogNextPageURL(nextPageURI: string) {
    return `${COLLECTION_MASTER_BASE_URL}${nextPageURI}`;
  },
  deleteDemoFieldBookURL() {
    return `${COLLECTION_MASTER_BASE_URL}/fieldBook/delete-multiple`;
  },
  getRepInfoTrialMasterURL() {
    return `${COLLECTION_MASTER_BASE_URL}/repbook`;
  },
  getRepInfoNextPageTrialMasterURL(nextPageURI: string) {
    return `${COLLECTION_MASTER_BASE_URL}${nextPageURI}`;
  },

  getAnalysisStateURL() {
    return `${TRIAL_MASTER_BASE_URL}/Enum/RepAnalysisStateEnum`;
  },

  getFieldMapRepInfoURL(id: string) {
    return `${TRIAL_MASTER_BASE_URL}/triallocation/${id}/rep/map`;
  },

  getFieldMapRepInfoNextPageURL(nextPageURI: string) {
    return `${TRIAL_MASTER_BASE_URL}${nextPageURI}`;
  },

  updateRepStatusURL(answerPlotLocationId: string) {
    return `${TRIAL_MASTER_BASE_URL}/triallocation/${answerPlotLocationId}/rep`;
  },
  getSoilTextureEnumURL() {
    return `${TRIAL_MASTER_BASE_URL}/Enum/SoilTextureEnum`;
  },
  getYieldEnvironmentEnumURL() {
    return `${TRIAL_MASTER_BASE_URL}/Enum/YieldEnvEnum`;
  },
  getMappingSheetNextPageURL(nextPageUri: string) {
    return `${TRIAL_MASTER_BASE_URL}/triallocation${nextPageUri}`;
  },
  getMappingSheetURL(seasonId?: string, teamId?: string) {
    return `${TRIAL_MASTER_BASE_URL}/triallocation/season/${seasonId}/mapping-sheet/team/${teamId}`;
  },
  substituteProductInFieldBookURL() {
    return `${TRIAL_MASTER_BASE_URL}/substitute/fieldBook`;
  },
  substituteProductInDemoTrialURL(demoTrialProductId: string) {
    return `${TRIAL_MASTER_BASE_URL}/substitute/demoTrial/product/${demoTrialProductId}`;
  },
  substituteProductInTrialURL(id: string) {
    return `${TRIAL_MASTER_BASE_URL}/substitute/trial/product/${id}`;
  },
  getReasonsToDiscardPlotURL() {
    return `${TRIAL_MASTER_BASE_URL}/discardPlot`;
  },
  getDemoInvntoryTrialMasterURL() {
    return `${TRIAL_MASTER_BASE_URL}/demoInventory`;
  },
  getDemoInventoryNextPageTrialMasterURL(nextPageURI: string) {
    return `${TRIAL_MASTER_BASE_URL}${nextPageURI}`;
  },
  getDemoTypeTrialMasterURL() {
    return `${TRIAL_MASTER_BASE_URL}/demoType`;
  },
  getDemoInventoryById(id?: string) {
    return `${TRIAL_MASTER_BASE_URL}/demoInventory/${id}`;
  },
  updateDemoInventoryTrialMasterURL(id: string) {
    return `${TRIAL_MASTER_BASE_URL}/demoInventory/${id}/addproducts`;
  },
  deleteDemoInventoryProductTrialMasterURL(
    id?: string,
    demoInventoryProductId?: string
  ) {
    return `${TRIAL_MASTER_BASE_URL}/demoInventory/${id}/product/${demoInventoryProductId}`;
  },
  patchDemoInventoryProductTrialMasterURL(id?: string | undefined) {
    return `${TRIAL_MASTER_BASE_URL}/demoInventory/${id}/products`;
  },
  getSignDataTrialMasterURL() {
    return `${TRIAL_MASTER_BASE_URL}/Enum/SignEnum`;
  },
  getLineOfBusinessDataTrialMasterURL() {
    return `${TRIAL_MASTER_BASE_URL}/Enum/LineOfBusinessEnum`;
  },
  getDemoTrialsTrialMasterURL() {
    return `${TRIAL_MASTER_BASE_URL}/demoTrial`;
  },
  getDemoTrialNextPageTrialMasterURL(nextPageURI: string) {
    return `${TRIAL_MASTER_BASE_URL}${nextPageURI}`;
  },

  getDemoTrialDataByIdTrialMasterURL(id: string) {
    return `${TRIAL_MASTER_BASE_URL}/demoTrial/${id}`;
  },
  getDemoTrialProductsByTrialId(id?: string) {
    return `${TRIAL_MASTER_BASE_URL}/demoTrial/${id}/products`;
  },

  getDemoTrialByIdNextPageTrialMasterURL(nextPageURI: string) {
    return `${TRIAL_MASTER_BASE_URL}${nextPageURI}`;
  },
  updateDemoTrialTrialMasterURL(id: string) {
    return `${TRIAL_MASTER_BASE_URL}/demoTrial/${id}/addproducts`;
  },
  getDeleteDemoTrialProductsURL(id: string, productId: string) {
    return `${TRIAL_MASTER_BASE_URL}/demoTrial/${id}/product/${productId}`;
  },
  getDemoTrialModifyProductURL(id: string) {
    return `${TRIAL_MASTER_BASE_URL}/demoTrial/${id}/products`;
  },
  deleteDemoTrialProductsTrialMasterURL(id: string) {
    return `${TRIAL_MASTER_BASE_URL}/demoTrial/${id}/deleteProducts`;
  },
  getAttributeURL() {
    return `${TRIAL_MASTER_BASE_URL}/attribute`;
  },
  protocolTrialMasterDataURL() {
    return `${TRIAL_MASTER_BASE_URL}/protocol`;
  },
  getProtocolNextPageURLTrialMasterDataURL(nextPageURI: string) {
    return `${TRIAL_MASTER_BASE_URL}${nextPageURI}`;
  },
  protocolTrialMasterDataURLById(id: number) {
    return `${TRIAL_MASTER_BASE_URL}/protocol/${id}`;
  },
  getLabBookURL(type: LabBookSampleTypes): string {
    switch (type) {
      case LabBookSampleTypes.TISSUE:
        return `${COLLECTION_MASTER_BASE_URL}/tissueSampleBook`;
      case LabBookSampleTypes.SOIL:
        return `${COLLECTION_MASTER_BASE_URL}/soilSampleBook`;
      case LabBookSampleTypes.NEMATOD:
        return `${COLLECTION_MASTER_BASE_URL}/nematodeSampleBook`;
      default:
        return `${COLLECTION_MASTER_BASE_URL}`;
    }
  },
  getLabBookNextPageURL(nextPageURI: string) {
    return `${COLLECTION_MASTER_BASE_URL}${nextPageURI}`;
  },
  ObservationGetAllURL(url: string) {
    return `${COLLECTION_MASTER_BASE_URL}/${url}`;
  },
  getObservationExportURL(url: string) {
    return `${REPORTING_BASE_URL}/${url}`;
  },
  getStakesURL() {
    return `${REPORTING_BASE_URL}/printing/stakes`;
  },
  getStakesNextPageURL(nextPageURI: string) {
    return `${REPORTING_BASE_URL}${nextPageURI}`;
  },
  getReportingAttributesURL() {
    return `${REPORTING_BASE_URL}/Report`;
  },

  getTrialReportingLocationURL() {
    return `${REPORTING_BASE_URL}/Report/triallocation`;
  },
  getTrialReportingLocationNextPage(nextPageURI: string) {
    return `${REPORTING_BASE_URL}${nextPageURI}`;
  },
  getReportingHeaderFooterURL() {
    return `${REPORTING_BASE_URL}/Report/Images`;
  },
  getReportingHeadersNextPageURl(nextPageURI: string) {
    return `${REPORTING_BASE_URL}${nextPageURI}`;
  },
  getReportingTrialsURL() {
    return `${REPORTING_BASE_URL}/Report/repBookTrials`;
  },
  getReportingTrialsNextPageURl(nextPageURI: string) {
    return `${REPORTING_BASE_URL}${nextPageURI}`;
  },
  getReportImage(id: number) {
    return `${REPORTING_BASE_URL}/Report/Images/${id}`;
  },

  getCommercialEntryMeansReportURL() {
    return `${REPORTING_BASE_URL}/Report/entrymeans/Commercial`;
  },

  getProductManagerReportURL() {
    return `${REPORTING_BASE_URL}/Report/entrymeans/ProductManager`;
  },

  getQcReportURL() {
    return `${REPORTING_BASE_URL}/Report/qualitycheck`;
  },

  getOutlierReportURL() {
    return `${REPORTING_BASE_URL}/Report/outlier`;
  },

  getRepMeansReportURL() {
    return `${REPORTING_BASE_URL}/Report/Repmeans`;
  },

  getApplicationURL() {
    return `${COLLECTION_MASTER_BASE_URL}/ApplicationBook`;
  },
  getApplicationNextPageURL(nextPageURI: string) {
    return `${COLLECTION_MASTER_BASE_URL}${nextPageURI}`;
  },
  getDeleteBookEntriesURL(moduleName: string) {
    return `${COLLECTION_MASTER_BASE_URL}/${moduleName}/filtered-delete`;
  },

  getDeleteTrialMasterEntriesURL(moduleName: string) {
    return `${TRIAL_MASTER_BASE_URL}/${moduleName}/filtered-delete`;
  },

  getFieldBookExportBaseUrl() {
    return `${REPORTING_BASE_URL}/FieldBook`;
  },
  getPreviewFileURL() {
    return `${REPORTING_BASE_URL}/printing/receipt/preview`;
  },
  getReportingBaseURL() {
    return `${REPORTING_BASE_URL}`
  },
  getPrintJobFileURL() {
    return `${REPORTING_BASE_URL}/job`;
  },
  getPrintJobFileNextPageURL(nextPageUri: string) {
    return `${REPORTING_BASE_URL}${nextPageUri}`;
  },
  getNotesURL() {
    return `${TRIAL_MASTER_BASE_URL}/note`;
  },
  getNotesNextPageURL(nextPageURI: string) {
    return `${TRIAL_MASTER_BASE_URL}${nextPageURI}`;
  },
  getPicturesURL(resourceId: string, resourceType: string) {
    return `${TRIAL_MASTER_BASE_URL}/image/resourceId/${resourceId}/resourceType/${resourceType}`;
  },
  getFileStoreURL() {
    return `${FILE_STORE_BASE_URL}/download-file`;
  },
  getUserPreferencesURL(preferenceId?: string) {
    return `${TRIAL_AUTH_BASE_URL}/preference${preferenceId ? `/${preferenceId}` : ""
      }`;
  },
  getBulkColumnUpdateUrl(
    moduleName: string,
    isDataCollection?: boolean,
    isMasterDataCollection?: boolean
  ): string {
    let baseUrl = TRIAL_MASTER_BASE_URL; // default

    if (isMasterDataCollection) {
      baseUrl = TRIAL_MASTER_DATA_BASE_URL;
    } else if (isDataCollection) {
      baseUrl = COLLECTION_MASTER_BASE_URL;
    }
    return `${baseUrl}/${moduleName}/filtered-update`;
  },
  getBulkProductsByIdUpdateURL(moduleName: string): string {
    return `${TRIAL_MASTER_DATA_BASE_URL}/${moduleName}/bulk-update`;
  },
  getFilterSchemaURL(moduleName: string, schemaType: FilterSchemaType): string {
    let baseUrl: string;
    if (schemaType === FilterSchemaType.TRIAL_AUTH) {
      baseUrl = TRIAL_AUTH_BASE_URL;
    } else if (schemaType === FilterSchemaType.DATA_COLLECTION) {
      baseUrl = COLLECTION_MASTER_BASE_URL;
    } else if (schemaType === FilterSchemaType.TRIAL_MASTER) {
      baseUrl = TRIAL_MASTER_BASE_URL;
    }
    else if (schemaType === FilterSchemaType.TRIAL_REPORT) {
      baseUrl = REPORTING_BASE_URL
    }
    else if (schemaType === FilterSchemaType.COLLECTION_MASTER) {
      baseUrl = COLLECTION_MASTER_BASE_URL;
    }
    else {
      baseUrl = TRIAL_MASTER_DATA_BASE_URL;
    }
    return `${baseUrl}/${moduleName}/filter-schema`;
  },
  getBarcodeInventoryURL() {
    return `${this.getFieldBookURL()}/projected-fields`;
  },
  getRegionsURL() {
    return `${TRIAL_MASTER_BASE_URL}/region`;
  },
  getRegionByIdURL(regionId: number) {
    return `${TRIAL_MASTER_BASE_URL}/region/${regionId}`;
  },
  getRegionsNextPageURL(nextPageURI: string) {
    return `${TRIAL_MASTER_BASE_URL}${nextPageURI}`;
  },
  getContentLengthForRegionsURL() {
    return `${TRIAL_MASTER_BASE_URL}/region`;
  },
  getProductSetsByRegionURL() {
    return `${TRIAL_MASTER_BASE_URL}/OnFarmProductSet`;
  },
  getProductSetByIdURL(productSetId: number) {
    return `${TRIAL_MASTER_BASE_URL}/onFarmProductSet/${productSetId}`;
  },
  createProductSetURL() {
    return `${TRIAL_MASTER_BASE_URL}/onFarmProductSet`;
  },
  updateProductSetURL(regionId: number, productSetId: number) {
    return `${TRIAL_MASTER_BASE_URL}/onFarmProductSet/${productSetId}`;
  },
  deleteProductSetURL(regionId: number, productSetId: number) {
    return `${TRIAL_MASTER_BASE_URL}/onFarmProductSet/${productSetId}`;
  },
  createRegionURL() {
    return `${TRIAL_MASTER_BASE_URL}/region`;
  },
  updateRegionURL(regionId: string) {
    return `${TRIAL_MASTER_BASE_URL}/region/${regionId}`;
  },
  deleteRegionURL(regionId: string) {
    return `${TRIAL_MASTER_BASE_URL}/region/${regionId}`;
  },
  getRepBookCatalogURL() {
    return `${COLLECTION_MASTER_BASE_URL}/repbookcatalog`;
  },
  getOneToManyReportURL() {
    return `${REPORTING_BASE_URL}/OnFarmReport/OneToManyReport`;
  },

  getHeadToHeadReportURL() {
    return `${REPORTING_BASE_URL}/OnFarmReport/HeadToHeadReport`;
  },
  getOnFarmTrialsURL() {
    return `${REPORTING_BASE_URL}/OnFarmReport/OnFarmTrials`;
  },

  getSingleReportURL() {
    return `${REPORTING_BASE_URL}/OnFarmReport/SingleReport`;
  },

  getOnFarmProductSetURL() {
    return `${TRIAL_MASTER_BASE_URL}/OnFarmProductSet`;
  },

  getToDoDetailsURL() {
    return `${REPORTING_BASE_URL}/Dashboard/Todo`;
  },

  getToDoDetailsNextPageURL(nextPageURI: string) {
    return `${REPORTING_BASE_URL}${nextPageURI}`;
  },

  postCreateToDoURL() {
    return `${REPORTING_BASE_URL}/Dashboard/CreateTodo`;
  },

  getDashboardStatusURL(season: string) {
    return `${REPORTING_BASE_URL}/Dashboard/TodoBySeason/${season}`;
  },

  getTrialBookDetailsURL() {
    return `${REPORTING_BASE_URL}/Dashboard/TrialBookDetails`;
  },

  getTrialBookDetailsNextPageURL(nextPageURI: string) {
    return `${REPORTING_BASE_URL}${nextPageURI}`;
  },

  getFieldRepDetailsURL() {
    return `${REPORTING_BASE_URL}/Dashboard/FieldTeamRepInfo`;
  },

  getFieldRepDetailsNextPageURL(nextPageURI: string) {
    return `${REPORTING_BASE_URL}${nextPageURI}`;
  },

  getTodoFilterSchemaURL() {
    return `${REPORTING_BASE_URL}/Dashboard/Todo/filter-schema`;
  },

  getTrialBookFilterSchemaURL() {
    return `${REPORTING_BASE_URL}/Dashboard/TrialBook/filter-schema`;
  },

  getFieldRepFilterSchemaURL() {
    return `${REPORTING_BASE_URL}/Dashboard/FieldRep/filter-schema`;
  },
};


